import backgroundVindi from '@assets/images/admin/devise/background-vindi.png';

const defaultBackground = {
  background: `url(${backgroundVindi})`,
  backgroundColor: '#F8F8F8D6',
  backgroundSize: '60%',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'left bottom',
};

const defaultContainer = { height: '100vh' };

export const smallScreenStyles = {
  containerStyle: {
    ...defaultContainer,
  },

  advertsStyles: {
    ...defaultBackground,
    padding: '40px',
  },

  formStyles: {
    backgroundColor: '#fff',
    justifyContent: 'center',
    alignItems: 'center',
  },
};

export const largeScreenStyles = {
  containerStyle: {
    ...defaultContainer,
  },

  advertsStyles: {
    ...defaultBackground,
    padding: '40px',
  },
  formStyles: {
    backgroundColor: '#fff',
    paddingLeft: '130px',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
};
